module.exports = __webpack_public_path__ + "static/media/step_error_icon.a55131f9.svg";